import * as service from "../service";
import { getEventDateRange } from "@/utils/eventDateFilter";
import { store } from "../../store";
import type { ServiceResponse } from "../types";
import type { StudentEvent } from "../user/events";

export type SearchEventsParams = {
  searchText: string;
  page?: number;
  postType?: string[];
  society?: { id: string }[];
  university?: string[];
  datePreset?: string;
  openOnly?: boolean;
  location?: string;
  hashtag?: string;
};

/**
 * Full-text search over events (title / description / hash tags). The result
 * page has the same shape as the home feed and is paginated 10 per page.
 * `postType` / `society` / `university` mirror the `getEvents` filters, so the
 * student home feed can combine a search query with its filter modal.
 * Backend: GET /api/search/searchEvents/searchEvents
 */
export const SearchEventsAPI = async ({
  searchText,
  page = 1,
  postType,
  society,
  university,
  datePreset,
  openOnly,
  location,
  hashtag,
}: SearchEventsParams): Promise<ServiceResponse<StudentEvent[]>> => {
  const { user } = store.getState().auth as any;
  const dateRange = getEventDateRange(datePreset);
  try {
    const resp = await service.call(
      "GET",
      "api/search/searchEvents/searchEvents",
      {
        user_id: user?.id,
        search_text: searchText,
        page,
        ...dateRange,
        ...(postType && postType.length > 0 ? { post_type: postType } : {}),
        ...(society && society.length > 0 ? { society } : {}),
        ...(university && university.length > 0 ? { university } : {}),
        ...(openOnly ? { open_only: 1 } : {}),
        ...(location?.trim() ? { location: location.trim() } : {}),
        ...(hashtag?.trim()
          ? { hashtag: hashtag.trim().replace(/^#/, "") }
          : {}),
      },
    );
    return resp;
  } catch (err) {
    console.error(`SearchEventsAPI ${err}`);
    return { status: -1 };
  }
};
